export default __webpack_public_path__ + "static/media/August2011.92d408ed.png";